import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { AVAILABLE_STATUS_LIST, TITLE_MAPPING } from './constants';
import { ErrorContent } from '../../components/ErrorContent';
import { ESubscriptionLimitType } from '../../types/context';
import { useContext } from '../../utils/useContext';

export const FallbackModalContainer: React.FC = () => {
  const context = useContext();
  const offerId = context.lastUsedOfferId;

  const content = React.useMemo(() => {
    switch (context.status) {
      case 'failed': {
        const { checkContactsAccess } = context;

        // Если offerId недоступен, не показываем кнопку retry
        if (!offerId) {
          return null;
        }

        return (
          <ErrorContent
            onRetry={() => checkContactsAccess({ offerId, limitType: ESubscriptionLimitType.PhoneNumber })}
          />
        );
      }
      default:
        return null;
    }
  }, [context, offerId]);

  if (!AVAILABLE_STATUS_LIST.includes(context.status)) {
    return null;
  }

  return (
    <ModalWindow
      open={context.open}
      onClose={context.onClose}
      title={TITLE_MAPPING[context.status]}
      width="100%"
      maxWidth={540}
      content={content}
      escape={false}
      size="M"
      fixed
    />
  );
};
